<template>
  <div class="intro">
    <div class="intro__container">
    <transition name="intro__fade-transition" appear>
      <video class="intro__video" ref="introVideo" @ended="emits('skipIntro')" playsinline autoplay muted preload="auto">
        <source src="https://static.serato.com/visualizer/videos/onboarding-video.mp4" type="video/mp4">
          Your browser does not support the video tag.
      </video>
    </transition>
    <div class="intro__button-wrapper">
      <transition name="intro__fade-transition" appear>
        <big-button
          v-if="showPlayButton"
          class="intro__play-button"
          text="Click for sound"
          type="secondary"
          :is-loading="false"
          :is-disabled="false"
          @click="playSound"
        >
          <unmute-icon />
        </big-button>
      </transition>
      <transition name="intro__fade-transition" appear>
        <big-button
          style="transition-delay: 3s;"
          text="Skip intro"
          type="secondary"
          :is-loading="false"
          :is-disabled="false"
          @click="emits('skipIntro')"
        >
          <forward-icon class="intro__skip-icon" />
        </big-button>
      </transition>
    </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import ForwardIcon from '@/assets/ForwardIcon.svg'
import BigButton from '@/components/common/BigButton.vue'
import { ref } from 'vue'
import UnmuteIcon from '@/assets/UnmuteIcon.svg'

const introVideo = ref<HTMLVideoElement | null>(null)
const showPlayButton = ref(true)

const playSound = () => {
  if (introVideo.value) {
    introVideo.value.muted = false
    showPlayButton.value = false
  }
}

const emits = defineEmits<{
  (event: 'skipIntro'): void;
}>()

</script>
<style lang="scss">
.intro {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100%;

  &__container {
    height: 100%;
    display: flex;
    @media (min-width: 2000px) {
      position: relative;
    }
  }

  &__video {
    max-width: 1920px;
    max-height: 1080px;
    margin: auto;
    width: 100%;
    height: auto;
    @media (min-aspect-ratio: 1920 / 1080) {
      height: 100%;
      width: auto;
    }
  }

  &__button-wrapper {
    position: absolute;
    display: flex;
    justify-content: center;
    bottom: 80px;
    gap: 10px;
    right: calc(50vw - 160px);
    @media (min-width: 480px) {
      right: 80px;
      gap: 20px;
    }
    @media (min-width: 2000px) {
      right: 0px;
    }
  }
  &__play-button {
    background-color: $purple;
  }
  &__skip-icon {
    height: 20px;
    width: 20px;
  }

  &__fade-transition {
    &-enter-active,
    &-leave-active {
      transition: opacity 200ms $animationCurve;
      pointer-events: none;
    }

    &-enter-from,
    &-leave-to {
      opacity: 0;
    }
  }
}
</style>
